import { useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';
import { Navigation, Square } from 'lucide-react';
import { api } from '../lib/api';

export function ShareLocationButton({ orderId, active, onToggle }) {
  const [on, setOn] = useState(false);
  const [count, setCount] = useState(0);
  const watch = useRef(null);
  const last = useRef(0);
  const stop = async () => {
    if (watch.current != null) navigator.geolocation.clearWatch(watch.current);
    watch.current = null; setOn(false); onToggle?.(false);
    try { await api.delete(`/orders/${orderId}/location`); } catch {}
  };
  const start = () => {
    if (!navigator.geolocation) return toast.error('Géolocalisation non disponible');
    watch.current = navigator.geolocation.watchPosition(async (p) => {
      if (Date.now() - last.current < 4000) return;
      last.current = Date.now();
      try { await api.post(`/orders/${orderId}/location`, { lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy }); setCount((c) => c + 1); }
      catch (e) { toast.error(e?.response?.data?.detail || 'Envoi position échoué'); stop(); }
    }, (e) => { toast.error(e.code === 1 ? 'Autorisez la localisation' : 'Position introuvable'); stop(); }, { enableHighAccuracy: true, maximumAge: 3000, timeout: 15000 });
    setOn(true); onToggle?.(true); toast.success("Position partagée en direct avec l'acheteur");
  };
  useEffect(() => () => { if (watch.current != null) navigator.geolocation.clearWatch(watch.current); }, []);
  if (!active) return null;
  return on ? (
    <button type="button" onClick={stop} data-testid={`share-loc-stop-${orderId}`} className="inline-flex items-center gap-2 px-3 py-2 rounded-full text-xs font-bold bg-[#E8B84A]/15 border border-[#E8B84A]/60 text-[#F5D98B]">
      <span className="h-2 w-2 rounded-full bg-[#E8B84A] animate-pulse" />Position en direct · {count} envoi{count > 1 ? 's' : ''}<Square className="h-3 w-3 ml-1" />
    </button>
  ) : (
    <button type="button" onClick={start} data-testid={`share-loc-start-${orderId}`} className="inline-flex items-center gap-2 px-3 py-2 rounded-full text-xs font-bold btn-gold">
      <Navigation className="h-3.5 w-3.5" />Partager ma position (livreur)
    </button>
  );
}
